var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionMarkCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon question-mark-circle-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "gray"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.059a.706.706 0 110 1.412.706.706 0 010-1.412zm0-8c1.516 0 2.824 1.253 2.824 2.823 0 1.416-.928 2.407-2.221 2.805-.122.036-.132.04-.132.023v.937a.47.47 0 01-.941 0v-.952c.01-.457.321-.769.802-.91.926-.284 1.55-.95 1.55-1.903C9.882 4.841 9.005 4 8 4c-1.041 0-1.882.784-1.882 1.882a.47.47 0 01-.942 0C5.176 4.25 6.453 3.06 8 3.06z"
  })));
}

export default SvgQuestionMarkCircleIconSv;